
import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobDetailedData } from '@/models/jobDetailed';
import PreviewJobStopDrawing from '@/components/jobDetailed//previewJob/PreviewJobStopDrawing.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import StopServices from '@/components/jobDetailed/StopServices.vue';

@Component({
  components: {
    PreviewJobStopDrawing,
    DateTimezoneToggle,
    StopServices,
  },
})
export default class PreviewJobDialogBody extends Vue {
  @Prop(Object) public job: JobDetailedData | null;
}
